import { UsageCapMetric as ProtoUsageCapMetric } from "@alch/protobufs-es/billing/billing_core_pb";
import z from "zod";
const UsageProductSchema = z.enum(["http", "webSockets", "webhooks"]);
const UsageActionUnit = z.enum(["USD", "CU"]);
const UsageCapMetric = z.nativeEnum({
  SUPERNODE_CU: ProtoUsageCapMetric.SUPERNODE_CU,
  BLAST_CU: ProtoUsageCapMetric.BLAST_CU,
  ALL_PRODUCTS: ProtoUsageCapMetric.ALL_PRODUCTS
});
const DEFAULT_USAGE_CAP_METRIC = UsageCapMetric.enum.SUPERNODE_CU;
export {
  DEFAULT_USAGE_CAP_METRIC,
  UsageActionUnit,
  UsageCapMetric,
  UsageProductSchema
};
//# sourceMappingURL=usage.js.map